import React from "react";

const PreviousWorkouts = () => {
  const workoutData = [
    { name: "Push Ups", date: "17/09/2024" },
    { name: "Incline Chest Press", date: "17/09/2024" },
    { name: "Squats", date: "18/09/2024" },
    { name: "Deadlifts", date: "19/09/2024" },
    { name: "Plank", date: "20/09/2024" },
    { name: "Jumping Jacks", date: "21/09/2024" },
    { name: "Burpees", date: "22/09/2024" },
    { name: "Lunges", date: "23/09/2024" },
    { name: "Pull Ups", date: "24/09/2024" },
    { name: "Bench Press", date: "25/09/2024" },
    { name: "Bicep Curls", date: "26/09/2024" },
    { name: "Tricep Dips", date: "27/09/2024" },
    { name: "Leg Press", date: "28/09/2024" },
    { name: "Shoulder Press", date: "29/09/2024" },
    { name: "Mountain Climbers", date: "30/09/2024" },
    { name: "Crunches", date: "01/10/2024" },
    { name: "Russian Twists", date: "02/10/2024" },
    { name: "High Knees", date: "03/10/2024" },
    { name: "Jump Rope", date: "04/10/2024" },
    { name: "Leg Raises", date: "05/10/2024" }
  ];

  return (
    <div className="container mt-4 py-2">
      <h6 className="text-left fw-bold">Previous Single Workouts</h6>

      <div className="mb-4">
        <div className="card-body">
          <div className="table-responsive" style={{ maxHeight: "300px",borderRadius: "10px" }}>
            <table className="table table-bordered mb-0 rounded-3">
              <thead className="bg-success text-white table-primary" style={{ position: "sticky", top: "0", zIndex: "1" }}>
                <tr>
                  <th className="ps-3">Workout Name</th>
                  <th className="ps-3">Date</th>
                </tr>
              </thead>
              <tbody>
                {workoutData.map((item, index) => (
                  <tr key={index}>
                    <td className="ps-3">{item.name}</td>
                    <td className="ps-3">{item.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviousWorkouts;
